import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@shared/ui/components";
import { ArrowRight } from "lucide-react";

interface CtaSectionProps {
  onStart: () => void;
}

export const CtaSection: React.FC<CtaSectionProps> = ({ onStart }) => {
  const navigate = useNavigate();

  const handleButtonClick = (): void => {
    onStart();
  };

  return (
    <section className="py-16 md:py-24 bg-foreground text-background">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-background/60">Попробуйте сами</p>
          <h2 className="mb-4 text-3xl font-bold md:text-4xl text-balance">150 минут — всего за 99 ₽</h2>
          <p className="mb-8 text-lg text-background/80 text-pretty">
            Расшифруйте первый файл и посмотрите, как это работает. 150 минут на 7 дней за 99 ₽, дальше 598 ₽/мес,
            отмена в один клик.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              variant="secondary"
              className="bg-background text-foreground hover:bg-background/90"
              onClick={handleButtonClick}
            >
              Начать работу
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-background/40 text-background hover:bg-background/10 bg-transparent"
              onClick={() => navigate("/pricing")}
            >
              Посмотреть тарифы
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
